module.exports = __webpack_public_path__ + "img/level1_idle_gun_shadow.f5ad016e.png";